import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";

const TerminosdeEnvios = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage} = useSelector(state => state.auth);

  const dispatch = useDispatch();

  /*cambiar el dispath*/

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }

  }, [successMessage, errorMessage, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="bg-slate-100 py-12">
        {/* Contenedor principal */}
        <div className="max-w-6xl mx-auto px-4">
          {/* Sección de Política de Envío */}
          <div className="bg-white rounded-lg shadow-md mb-12 overflow-hidden">
            <div className="p-8 md:p-10">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Política de Envío</h2>

              <div className="prose max-w-none">
                <ul className="space-y-5 list-disc pl-5 text-gray-700">
                  <li className="pb-3 border-b border-gray-100">
                    <strong>Autenticidad garantizada:</strong> Los modelos enviados por TEKOS.PE son 100% originales y pueden ser verificados en las tiendas oficiales de las marcas.
                  </li>

                  <li className="pb-3 border-b border-gray-100">
                    <strong>Costo fijo:</strong> El valor del envío no es negociable al realizar consultas por redes sociales.
                  </li>

                  <li className="pb-3 border-b border-gray-100">
                    <strong>Tiempos de entrega:</strong>
                    <ul className="list-[circle] pl-5 mt-2 space-y-2">
                      <li>
                        <span className="font-semibold">Lima:</span> 48 horas máximo
                      </li>
                      <li>
                        <span className="font-semibold">Provincia:</span> 72 horas máximo
                      </li>
                    </ul>
                  </li>

                  <li className="pb-3 border-b border-gray-100">
                    <strong>Seguimiento:</strong> Nuestros asesores se comunicarán después de registrar su compra para coordinar los detalles.
                  </li>

                  <li className="pb-3 border-b border-gray-100">
                    <strong>Requisitos:</strong> Es obligatorio presentar el comprobante de pago para el recojo de su pedido.
                  </li>

                  <li className="pb-3 border-b border-gray-100">
                    <strong>Tarifas:</strong>
                    <ul className="list-[circle] pl-5 mt-2 space-y-2">
                      <li>
                        Lima: <span className="font-semibold text-blue-600">S/10.00</span>
                      </li>
                      <li>
                        Provincia: <span className="font-semibold text-blue-600">S/5.00</span> inicial + cotización según destino
                      </li>
                    </ul>
                  </li>

                  <li>
                    <strong>Proceso para provincia:</strong>
                    <ol className="list-decimal pl-5 mt-2 space-y-2">
                      <li>
                        Seleccione <span className="font-semibold bg-gray-100 px-2 py-1 rounded">"ENVÍO AGENCIA"</span> al finalizar
                      </li>
                      <li>Pago inicial para agencias MARVISUR o SHALOM</li>
                      <li>Nuestro agente se comunicará para la cotización final</li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sección de Agencias de Envío */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">Nuestras Agencias de Envío</h2>

            <div className="grid grid-cols-2 md:grid-cols-1 gap-8">
              {/* Agencia Marvisur */}
              <div className="flex flex-col items-center p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-all duration-300">
                <h3 className="text-2xl font-semibold mb-4 text-blue-600">Marvisur</h3>
                <a href="https://www.expresomarvisur.com/sucursales" target="_blank" rel="noopener noreferrer" className="mb-4">
                  <img src="https://tekos.pe/wp-content/uploads/2022/08/marvisur.gif" alt="Logo Marvisur" className="w-full max-w-xs h-auto object-contain" loading="lazy" />
                </a>
                <p className="text-center text-gray-600 mt-auto">
                  <a href="https://www.expresomarvisur.com/sucursales" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                    Ver sucursales disponibles
                  </a>
                </p>
              </div>

              {/* Agencia Shalom */}
              <div className="flex flex-col items-center p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-all duration-300">
                <h3 className="text-2xl font-semibold mb-4 text-green-600">Shalom</h3>
                <a href="http://agencias.shalom.com.pe/" target="_blank" rel="noopener noreferrer" className="mb-4">
                  <img src="https://tekos.pe/wp-content/uploads/2022/08/shalom.gif" alt="Logo Shalom" className="w-full max-w-xs h-auto object-contain" loading="lazy" />
                </a>
                <p className="text-center text-gray-600 mt-auto">
                  <a href="http://agencias.shalom.com.pe/" target="_blank" rel="noopener noreferrer" className="text-green-500 hover:underline">
                    Ver sucursales disponibles
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TerminosdeEnvios;
